import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IGetEventTokenResponse } from '../../shared/interfaces';
import { ApiService } from '../../shared/api.service';
import { IAccountResetArgs } from './interfaces';

@Component({
    selector: 'aza-rws-profile-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css'],
    standalone: false
})
export class LoginComponent {
    email = '';
    password = '';
    loginFailed = false;
    showLogin = true;
    showResetPassword = false;
    showEmailCode = false;
    showVerificationCode = false;
    verificationCode: string;

    @Input() eventId = '';
    @Output() loggedIn = new EventEmitter<IGetEventTokenResponse>();
    @Output() closed = new EventEmitter<void>();
    @Output() accountReset = new EventEmitter<IAccountResetArgs>();

    constructor(private apiSvc: ApiService) {
    }

    async onLogin(): Promise<void> {
        try {
            const res = await this.apiSvc.profileLogin(this.email, this.password, this.eventId);
            this.loginFailed = false;
            this.loggedIn.next(res);
        } catch (err) {
            this.loginFailed = true;
        }
    }

    onForgotPassword(ev: Event): void {
        ev.preventDefault();
        this.showLogin = false;
        this.showResetPassword = true;
        this.showEmailCode = false;
        this.showVerificationCode = false;
    }

    async onVerifyEmail(ev: Event): Promise<void> {
        ev.preventDefault();
        try {
            await this.apiSvc.sendConfirmationCode(this.email);
            this.showLogin = false;
            this.showResetPassword = false;
            this.showEmailCode = false;
            this.showVerificationCode = true;
        } catch (err) {
        }
    }

    onResetAccount(ev: Event): void {
        ev.preventDefault();
        this.accountReset.next({ email: this.email, emailVerificationCode: this.verificationCode });
    }

    onClosed(): void {
        this.closed.next();
    }
}
